<template>
  <section class="section" id="account">
    <div class="container">
      <b-loading
        :is-full-page="true"
        :active="isLoading"
        :can-cancel="false"
      ></b-loading>

      <h1 class="title has-text-centered is-spaced">
        <span class="is-pulled-left">
          <router-link class="button" tag="button" to="/dashboard">
            <b-icon icon="arrow-alt-circle-left"></b-icon>
          </router-link>
        </span>
        {{ $t("account.title") }}
      </h1>
      <hr />

      <div class="columns">
        <div class="column">
          <h2 class="subtitle">
            {{ $t("account.companyInfo") }}
          </h2>

          <p>
            <b>{{ $t("account.companyName") }}: </b>
            {{ companyInfo.companyName }}
          </p>

          <p>
            <b>{{ $t("account.nationalCompanyId") }}: </b>
            {{ companyInfo.nationalCompanyId }}
          </p>

          <p>
            <b>{{ $t("account.stateCompanyId") }}: </b>
            {{ companyInfo.stateCompanyId }}
          </p>

          <p>
            <b>{{ $t("account.municipalCompanyId") }}: </b>
            {{ companyInfo.municipalCompanyId }}
          </p>
          <br />

          <!-- <h2 class="subtitle">{{ $t("account.bankInfo") }}</h2>

          <p>
            <b>{{ $t("account.bankName") }}: </b>
            {{ `${bankInfo.bankName} | ${bankInfo.bankCode}` }}
          </p>

          <p>
            <b>{{ $t("account.bankBranch") }}: </b>{{ bankInfo.bankBranch }}
          </p>

          <p>
            <b>{{ $t("account.accountType") }}: </b>{{ bankInfo.accountType }}
          </p>

          <p>
            <b>{{ $t("account.accountNumber") }}: </b>
            {{ `${bankInfo.accountNumber}-${bankInfo.accountDigit}` }}
          </p>
          <br /> -->

          <!-- <h2 class="subtitle">{{ $t("account.timezone") }}</h2>

          <b-select
            v-model="timezone"
            @input="updateTimezone"
            placeholder="GMT-03"
          >
            <option :value="11">GMT+11</option>
            <option :value="10">GMT+10</option>
            <option :value="9">GMT+09</option>
            <option :value="8">GMT+08</option>
            <option :value="7">GMT+07</option>
            <option :value="6">GMT+06</option>
            <option :value="5">GMT+05</option>
            <option :value="4">GMT+04</option>
            <option :value="3">GMT+03</option>
            <option :value="2">GMT+02</option>
            <option :value="1">GMT+01</option>
            <option :value="0">GMT+00</option>
            <option :value="-1">GMT-01</option>
            <option :value="-2">GMT-02</option>
            <option :value="-3">GMT-03</option>
            <option :value="-4">GMT-04</option>
            <option :value="-5">GMT-05</option>
            <option :value="-6">GMT-06</option>
            <option :value="-7">GMT-07</option>
            <option :value="-8">GMT-08</option>
            <option :value="-9">GMT-09</option>
            <option :value="-10">GMT-10</option>
            <option :value="-11">GMT-11</option>
          </b-select> -->
        </div>

        <div class="column">
          <h2 class="subtitle">{{ $t("account.companyAddress") }}</h2>

          <p>
            <b>{{ $t("account.state") }}: </b>{{ address.state }}
          </p>

          <p>
            <b>{{ $t("account.city") }}: </b>
            {{ address.city }}
          </p>

          <p>
            <b>{{ $t("account.neighborhood") }}: </b>
            {{ address.neighborhood }}
          </p>

          <p>
            <b>{{ $t("account.street") }}: </b>
            {{ `${address.street}, ${address.number}` }}
          </p>

          <p>
            <b>{{ $t("account.complement") }}: </b>
            {{ address.complement || "-" }}
          </p>
          <br />
        </div>

        <div class="column">
          <h2 class="subtitle">{{ $t("account.ownerInfo") }}</h2>

          <p>
            <b>{{ $t("common.name") }}: </b>
            {{ `${ownerInfo.name} ${ownerInfo.surname}` }}
          </p>

          <p>
            <b>{{ $t("common.personalId") }}: </b>
            {{ ownerInfo.personalId }}
          </p>

          <p>
            <b>{{ $t("common.email") }}: </b>
            {{ ownerInfo.email }}
          </p>

          <p>
            <b>{{ $t("common.cellphone") }}: </b>
            {{ ownerInfo.cellphone }}
          </p>
        </div>
      </div>

      <hr />

      <form @submit.prevent="updatePassword">
        <h1 class="title has-text-centered">
          {{ $t("account.updatePasswordTitle") }}
        </h1>

        <div class="columns">
          <div class="column"></div>
          <div class="column is-half">
            <b-field>
              <b-input
                size="is-medium"
                v-model="password"
                type="password"
                :placeholder="$t('account.currentPassword')"
                password-reveal
              ></b-input>
            </b-field>

            <b-field>
              <b-input
                size="is-medium"
                v-model="newPassword"
                type="password"
                :placeholder="$t('account.newPassword')"
                password-reveal
              ></b-input>
            </b-field>

            <button
              class="button is-medium is-fullwidth has-text-weight-bold"
              :style="{
                backgroundColor: $primaryColor,
                color: $primaryColorContrast
              }"
              type="submit"
            >
              {{ $t("account.updateActionButton") }}
            </button>
          </div>
          <div class="column"></div>
        </div>
      </form>

      <hr />

      <h2 class="title has-text-centered my-5">
        {{ $t("account.languageHeader") }}
      </h2>
      <flag-icons />

      <hr />

      <h2 class="title has-text-centered my-5">
        {{ $t("contact.title") }}
        <b-icon icon="comments"></b-icon>
      </h2>

      <h2 class="subtitle is-spaced has-text-centered">
        {{ $t("contact.subtitle") }}
      </h2>

      <h2 class="subtitle is-spaced has-text-centered">
        {{ $t("contact.supportWhatsapp") }}:
        <a
          href="https://wa.me/554799541307"
          target="_blank"
          rel="noopener noreferrer"
        >
          (47) 99954-1307
        </a>
      </h2>

      <h2 class="subtitle is-spaced has-text-centered" v-if="$chain === 'onii'">
        {{ $t("contact.ticketsPortal") }}:
        <a href="https://portal.onii.app" target="_blank">portal.onii.app</a>
      </h2>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";
import flagIcons from "../login/common/FlagIcons";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      password: "",
      newPassword: "",
      timezone: -3
    };
  },

  components: {
    flagIcons
  },

  methods: {
    updatePassword() {
      this.isLoading = true;
      this.$store
        .dispatch("updatePassword", {
          password: this.password,
          newPassword: this.newPassword
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.password = "";
            this.newPassword = "";
            this.$buefy.dialog.alert({
              title: "Sucesso!",
              message: "Senha atualizada 🤘",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa"
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    updateTimezone() {
      this.isLoading = true;
      this.$store
        .dispatch("updateTimezone", {
          timezone: this.timezone
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.toast.open({
              message: `${this.$t("account.timezoneUpdated")}!`,
              type: "is-success",
              position: "is-bottom",
              duration: 3000
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters([
      "ownerInfo",
      "companyInfo",
      "address",
      "bankInfo",
      "preferences",
      "permissions"
    ])
  },

  mounted() {
    this.timezone = this.preferences.timezone;
  }
};
</script>

<style scoped>
#account {
  margin-top: 3rem;
  min-height: 94vh;
  padding: 2rem 1rem;
  background-color: hsl(0, 0%, 96%);
}
hr {
  background-color: hsl(0, 0%, 71%);
}
.box .icon {
  position: relative;
  top: 6px;
}
.flags {
  width: 100%;
  margin: 0 auto;
}
</style>
